<template>
  <li>
    <router-link
      :to="{ name: 'item-edit', params: { id: id } }"
      :class="{ 'has-background-warning': inQuery }">{{ name }}</router-link>

    <ul v-if="children">
      <list-item
        v-for="item in children"
        :key="item.id"
        :id="item.id"
        :children="item.children"
        :name="item.name"
        :matches="matches"
      ></list-item>
    </ul>
  </li>
</template>

<script>
  export default {
    props: [
      'id',
      'name',
      'children',
      'matches'
    ],
    computed: {
      inQuery () {
        if (this.matches.indexOf(this.id) > -1) return true
        return false
      }
    },
    name: 'list-item',
    created () {
      this.$on('search', (payload) => {
        console.log(payload);
      })
    }
  }
</script>

<style scoped>
  /* https://two-wrongs.com/draw-a-tree-structure-with-only-css */

  ul, li {
    position: relative;
  }

  ul {
    list-style: none;
    padding-left: 32px;
  }

  li::before, li::after {
    content: "";
    position: absolute;
    left: -12px;
  }

  li::before {
    border-top: 1px dashed #000;
    top: 12px;
    width: 8px;
    height: 0;
  }

  li::after {
    border-left: 1px dashed #000;
    height: 100%;
    width: 0px;
    top: 5px;
  }

  ul > li:last-child::after {
    height: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/ListItem.vue